import { render, staticRenderFns } from "./PengurusWilayahAdd.vue?vue&type=template&id=178febe5&scoped=true"
import script from "./PengurusWilayahAdd.vue?vue&type=script&lang=js"
export * from "./PengurusWilayahAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178febe5",
  null
  
)

export default component.exports